import { defineComponent as p, openBlock as t, createElementBlock as o, mergeProps as u, unref as a, renderSlot as g, createElementVNode as e, createCommentVNode as m } from "vue";
import { useScalarIcon as H } from "../hooks/useScalarIcon.js";
const L = { key: 0 }, f = { key: 1 }, h = { key: 2 }, A = { key: 3 }, k = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconArrowsHorizontal"
}, _ = /* @__PURE__ */ p({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = H(s);
    return (i, l) => (t(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(d)), [
      g(i.$slots, "default"),
      a(n) === "bold" ? (t(), o("g", L, l[0] || (l[0] = [
        e("path", { d: "M240.49,136.49l-32,32a12,12,0,0,1-17-17L203,140H53l11.52,11.51a12,12,0,0,1-17,17l-32-32a12,12,0,0,1,0-17l32-32a12,12,0,1,1,17,17L53,116H203l-11.52-11.51a12,12,0,0,1,17-17l32,32A12,12,0,0,1,240.49,136.49Z" }, null, -1)
      ]))) : a(n) === "duotone" ? (t(), o("g", f, l[1] || (l[1] = [
        e("path", {
          d: "M232,128l-32,32H56L24,128,56,96H200Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M237.66,133.66l-32,32a8,8,0,0,1-11.32-11.32L212.69,136H43.31l18.35,18.34a8,8,0,0,1-11.32,11.32l-32-32a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,11.32L43.31,120H212.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,237.66,133.66Z" }, null, -1)
      ]))) : a(n) === "fill" ? (t(), o("g", h, l[2] || (l[2] = [
        e("path", { d: "M237.66,133.66l-32,32A8,8,0,0,1,192,160V136H64v24a8,8,0,0,1-13.66,5.66l-32-32a8,8,0,0,1,0-11.32l32-32A8,8,0,0,1,64,96v24H192V96a8,8,0,0,1,13.66-5.66l32,32A8,8,0,0,1,237.66,133.66Z" }, null, -1)
      ]))) : a(n) === "light" ? (t(), o("g", A, l[3] || (l[3] = [
        e("path", { d: "M236.24,132.24l-32,32a6,6,0,0,1-8.48-8.48L217.51,134h-179l21.75,21.76a6,6,0,1,1-8.48,8.48l-32-32a6,6,0,0,1,0-8.48l32-32a6,6,0,0,1,8.48,8.48L38.49,122h179l-21.75-21.76a6,6,0,0,1,8.48-8.48l32,32A6,6,0,0,1,236.24,132.24Z" }, null, -1)
      ]))) : a(n) === "regular" ? (t(), o("g", k, l[4] || (l[4] = [
        e("path", { d: "M237.66,133.66l-32,32a8,8,0,0,1-11.32-11.32L212.69,136H43.31l18.35,18.34a8,8,0,0,1-11.32,11.32l-32-32a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,11.32L43.31,120H212.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,237.66,133.66Z" }, null, -1)
      ]))) : a(n) === "thin" ? (t(), o("g", w, l[5] || (l[5] = [
        e("path", { d: "M234.83,130.83l-32,32a4,4,0,0,1-5.66-5.66L222.34,132H33.66l25.17,25.17a4,4,0,0,1-5.66,5.66l-32-32a4,4,0,0,1,0-5.66l32-32a4,4,0,0,1,5.66,5.66L33.66,124H222.34L197.17,98.83a4,4,0,0,1,5.66-5.66l32,32A4,4,0,0,1,234.83,130.83Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  _ as default
};
